import { __assign, __rest } from "tslib";
import React from 'react';
import c from 'classnames';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import s from './SimpleLink.scss';
export var SimpleLink = function (_a) {
    var className = _a.className, children = _a.children, _b = _a.size, size = _b === void 0 ? 'medium' : _b, isGreen = _a.isGreen, props = __rest(_a, ["className", "children", "size", "isGreen"]);
    return (React.createElement(PlainButtonOrLink, __assign({}, props, { className: c(className, s['link'], isGreen && s['green'], s[size]) }), children));
};
SimpleLink.displayName = 'SimpleLink';
export default SimpleLink;
//# sourceMappingURL=SimpleLink.js.map